import { useMemo } from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { projects, type ProjectMeta } from '../data/site'

export type Project = ProjectMeta & { title: string; description: string }

export function useProjects(): Project[] {
  const { t } = useLanguage()
  return useMemo(
    () =>
      projects.map((p) => ({
        ...p,
        ...t.portfolio.projects[p.id as keyof typeof t.portfolio.projects],
      })),
    [t],
  )
}
